import { isValidImage } from '@/mixins/utils.js'
import groupplaceholder from '@/assets/images/groupplaceholder.png'

const validateLocationName = text => {
  const size = String(text).trim().length
  return size >= 3 && size <= 64
}

const validateGroupName = text => {
  const size = String(text).trim().length
  return size >= 3 && size <= 64
}

const validateGroupDescription = text => {
  const size = String(text).trim().length
  return size >= 3 && size <= 128
}

const isValidGroupImage = imageUrl => !!imageUrl === true && typeof imageUrl === 'string' && imageUrl.indexOf('https://firebasestorage.googleapis.com/') !== -1

const sanitizeGroupImage = imageUrl => !!imageUrl === true && typeof imageUrl === 'string' && imageUrl.indexOf('&token=') !== -1 ? imageUrl.split('&token=')[0] : imageUrl

const handleGroupImageLoad = async groupImageFileBase64 => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = () => {
      resolve({
        code: 1,
        response: {
          width: img && img.width ? img.width : false,
          height: img && img.height ? img.height : false,
        },
      })
    }

    img.onerror = groupImageLoadError => {
      resolve({
        code: 0,
        response: groupImageLoadError,
      })
    }

    img.src = groupImageFileBase64 // Aparentemente o Image() requer que o valor dessa propriedade seja atribuído
  })
}

const handleGroupImageFileLoad = async groupImageFile => {
  return new Promise((resolve, reject) => {
    /* FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO */
    if (!!groupImageFile === false) {
      resolve({
        code: 0,
        response: false, // 'cancelado'
        error: groupImageFile,
      })
    } else {
      /* VERIFICA SE O ARQUIVO É DO TIPO JPEG, JPG ou PNG */

      const contentType = !!groupImageFile === true && !!groupImageFile.type === true && typeof groupImageFile.type === 'string' ? groupImageFile.type : ''
      const type = contentType ? contentType.split('/')[1] : ''

      if (type !== 'png' && type !== 'jpg' && type !== 'jpeg') {
        resolve({
          code: 0,
          response: 'Não é possível processar o arquivo escolhido. Por favor, selecione um arquivo do tipo JPEG, JPG ou PNG.',
          error: '',
        })
      } else {
        /* PROCESSA ARQUIVO/IMAGEM SELECIONADA */

        const groupImageFileReader = new FileReader()

        groupImageFileReader.readAsDataURL(groupImageFile)

        groupImageFileReader.onload = async groupImageFileLoadSuccess => {
          /* NESSE PONTO O ARQUIVO DA IMAGEM JÁ FOI CARREGADO, AGORA O "CONTEÚDO DA IMAGEM" SERÁ GUARDADO EM UMA CONSTANTE */

          const groupImageFileBase64 = groupImageFileLoadSuccess.target.result

          /* PROCESSA O CONTEÚDO ACIMA A FIM DE BUSCAR AS DIMENSÕES DA IMAGEM CARREGADA */

          const loadGroupImage = await handleGroupImageLoad(groupImageFileBase64)

          /* NESSE PONTO A IMAGEM JÁ FOI PROCESSADA E O CARREGAMENTO DO ARQUIVO SERÁ CONCLUÍDO */

          if (loadGroupImage.code === 0) {
            resolve({
              code: 0,
              response: 'Não foi possível ler a imagem. Por favor, tente novamente ou fale com o nosso suporte.',
              error: loadGroupImage,
            })
          } else {
            const isGroupImageInvalid = groupImageFile.size > 1000000 || loadGroupImage.response.width > 1000 || loadGroupImage.response.height > 1000 || loadGroupImage.response.width < 200 || loadGroupImage.response.height < 200

            if (isGroupImageInvalid) {
              resolve({
                code: 0,
                response: 'Por favor, selecione uma imagem com as seguintes características:<br /><ul style="margin-top: 10px"><li>Largura e altura mínima: 200x200</li><li>Largura e altura máxima: 1000x1000</li><li>Peso máximo: 1 MB</li></ul>',
                error: '',
              })
            } else {
              resolve({
                code: 1,
                response: {
                  // file: groupImageFile,
                  preview: groupImageFileBase64, // groupImageFileReader.result
                  size: groupImageFile.size,
                  width: loadGroupImage.response.width,
                  height: loadGroupImage.response.height,
                },
                error: '',
              })

              // console.log('::: onGroupImageSelect > image > loaded [2]:', groupImageFileReader.result)
            }
          }
        }

        groupImageFileReader.onerror = groupImageFileLoadError => {
          resolve({
            code: 0,
            response: 'Não foi possível ler o arquivo. Por favor, tente novamente ou fale com o nosso suporte.',
            error: groupImageFileLoadError,
          })
        }
      }
    }
  })
}

//
//
//
// FUNÇÕES QUE ESTAVAM NA STORE.JS
//
//
//

//
// LOCAIS DO GRUPO
//

const processGroupLocations = group => {
  const groupPlaces = !!group === true && !!group.locais === true && typeof group.locais === 'object' ? Object.entries(group.locais) : []

  return groupPlaces.map(([groupPlaceID, local]) => {
    if (!!local === false) return false

    const groupPlaceName = String(local.nome || '').trim()
    const groupPlaceLatitude = local.latitude || false
    const groupPlaceLongitude = local.longitude || false
    const groupPlaceRadius = local.radius || false
    const groupPlaceTimestamp = local.timestamp || false

    if (!!groupPlaceName === false && !!groupPlaceLatitude === false && !!groupPlaceLongitude === false && !!groupPlaceRadius === false && !!groupPlaceTimestamp === false) return false

    return {
      groupPlaceID,
      groupPlaceName,
      groupPlaceLatitude,
      groupPlaceLongitude,
      groupPlaceRadius,
      groupPlaceTimestamp,
      isGroupLocationGeofenced: !!groupPlaceLatitude === true && !!groupPlaceLongitude === true && !!groupPlaceRadius === true,
    }
  }).filter(filtro => !!filtro === true)
}

const buildGroupObject = (groupID, g) => {
  return {
    groupID,

    groupImage: isValidImage(g.img || '') ? String(g.img).trim() : groupplaceholder,
    groupName: !!g.nome === true && typeof g.nome === 'string' ? g.nome.trim() : '',
    groupDescription: !!g.des === true && typeof g.des === 'string' ? g.des.trim() : '',
    groupCnpj: g.cnpj ? g.cnpj.trim() : '',

    presetLocations: g.fixLocais,
    groupLocations: processGroupLocations(g),

    allowCreateDuty: g.allowCreateDuty || false,
    allowPassDuty: g.allowPassDuty || false,
    startShiftOnDayOnly: g.startShiftOnDayOnly || false,
    allowPauseDuringShift: g.allowPauseDuringShift || false,
    disableShiftStart: g.disableShiftStart || false,
    disableShiftEnd: g.disableShiftEnd || false,
    remindShiftStart: g.remindShiftStart || false,
    hideDutyValue: g.hideDutyValue || false,
    hideGroupShiftsTab: g.hideGroupShiftsTab || false,

    approvePassDuty: g.approvePassDuty || false,
    whoCanAcceptOrRefuse: !!g.approvePassDuty === true && !!g.whoCanAcceptOrRefuse === true && g.whoCanAcceptOrRefuse === 'apenas_gestores',

    allowDutyCandidates: g.allowDutyCandidates || false,
    disablePassToGroupAndUser: g.disablePassToGroupAndUser || false,
    disablePassToGroup: g.disablePassToGroup || false,
    sequentialShiftConflicts: g.sequentialShiftConflicts || false,
    sequentialShiftConflictsInterval: g.sequentialShiftConflictsInterval ? g.sequentialShiftConflictsInterval : '60',

    superAdminGroupDeleteFlag: g.superAdminGroupDeleteFlag || false,

    groupUsers: g.users || {},

    // groupInviteID: g.idconvite ? g.idconvite.trim() : '',

    // [master-portaltelemedicina]
    // maxConsultationRequestDayOfMonth: !!g.maxConsultationRequestDayOfMonth === true ? g.maxConsultationRequestDayOfMonth : false,
  }
}

//
// EXPORTS
//

export {
  validateLocationName,
  validateGroupName,
  validateGroupDescription,
  isValidGroupImage,
  sanitizeGroupImage,
  // handleGroupImageLoad,
  handleGroupImageFileLoad,
  processGroupLocations,
  buildGroupObject,
}
